'use strict';

var format = require('string-format');
var tuneInRequest = require('../tuneInRequest');

module.exports = function redirectInfoService(config, apiContext) {
  return function getRedirectInfo(guideId) {
    return tuneInRequest({
      method: 'get',
      url: format('{}/profiles/{}', config.domains.api, guideId)
    }, apiContext);
  };
};
//# sourceMappingURL=redirectInfo.js.map